import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { fetchTransporter } from "../features/transporter/transporterSlice";

import TransporterForm from "./TransporterForm";
import TransporterTable from "./TransporterTable";

function Transporter() {

    const dispatch = useDispatch();

    const { loading, error } = useSelector(
        (state) => state.transporter
    );

    useEffect(() => {

        dispatch(fetchTransporter());

    }, [dispatch]);

    if (loading) {

        return (

            <div className="text-center mt-5">

                <div className="spinner-border text-primary"></div>

            </div>

        );

    }

    if (error) {

        return (

            <div className="alert alert-danger">

                {error}

            </div>

        );

    }

    return (

        <div className="container-fluid mt-3">

            <div className="row">

                <div className="col-lg-4">

                    <TransporterForm />

                </div>

                <div className="col-lg-8">

                    <TransporterTable />

                </div>

            </div>

        </div>

    );

}

export default Transporter;